<template>
<div>
    <br>
    <div class="row columns">
        <div class="large-3 columns">
            <select id="" name="" v-model="selectedFilter" >
                <option v-bind:value="0">tous les matchs</option>
                <option v-bind:value="1">les matchs en cours de saisie</option>
                <option v-bind:value="2">les matchs publiés</option>
            </select>
        </div>
        <div class="large-4 large-offset-4 columns">
                <router-link :to="{ name: 'mrStep1', params:{'id':'0'}}" >
                <button class=""><span><i class="fa fa-star" aria-hidden="true"></i>&nbsp;Nouveau Rapport de match</span></button></a>
                </router-link>
        </div>
    </div>
    <div v-if="matchReportList.length != 0" v-for="mr in filteredList" >
        <mrHeader :actions="true" class="match-header" :match="mr"></mrHeader>
        <hr>
    </div>
    <div v-else class="row columns">
        <div class="large-4 large-centered columns">
           Vos équipes n'ont encore joué aucun match 
        </div>
    </div>
    <br>
</div>
</template>

<script>
import { mapGetters } from 'vuex'
import mrHeader from '../match-reports/mr-header.vue'
import store from '../../store/index.js'

export default {
  name: 'myMatch',
  components: {
    mrHeader
  },
  props: {
  },
  data () {
    return {
      selectedFilter: '0'
    }
  },
  computed: {
    ...mapGetters([
      'matchReportList',
      'currentUser'
    ]),
    filteredList: function () {
      let filteredList = this.matchReportList
      if (this.selectedFilter === 1) {
        filteredList = this.matchReportList.filter(mr => { return mr.status === 0 })
      } else if (this.selectedFilter === 2) {
        filteredList = this.matchReportList.filter(mr => { return mr.status !== 0 })
      }
      return filteredList
    }
  },
  created () {
    store.dispatch('invalidatMatchReportList')
    if (!this.currentUser) {
      store.subscribe((mutation, state) => {
        if (mutation.type === 'setUser') {
          store.dispatch('getAllMatchReportForCoach', this.currentUser.id)
        }
      })
    } else {
      store.dispatch('getAllMatchReportForCoach', this.currentUser.id)
    }
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.big-title {
    font-size: 1.6rem;
}
.billboard {
    background-color: rgba(255,255,255,0.9);
    border-width: 1px;
    border-style: solid;
    border-color: #E1E5EC;
    margin: 1rem 0rem 1rem 0rem;
    box-shadow: 0 1px 3px rgba(0,0,0,0.12),0 1px 2px rgba(0,0,0,0.24);
    -webkit-transition: opacity 0.2s, -webkit-transform 0.2s;
	transition: opacity 0.35s, transform 0.5s;
    overflow: hidden;
}

.billboard:hover {
    -webkit-transform: scale3d(0.9,0.9,0.9);
	transform: scale3d(1.1,1.1,1);
    box-shadow: 1px 1px 3px rgba(0,0,0,0.7);
}

.billboard-thumbnail {
    padding: 0rem;
    margin: 0rem;
}

.billboard-content {
    padding: 1rem 1rem;
    overflow: inherit;
}
.tabs {
    border-style: none;
    padding-top: 1.2rem;
    border-bottom: 1px solid #cacaca;
    padding-bottom: 0.4rem
}


.tabs li{
    float: left;
    margin-left : 0rem;
    /* padding : 0.4rem 0.8rem ; */
    margin-right : 0rem;
    /* position: relative; */
    bottom: -1px;
    margin-bottom:0rem;
}

.tabs li a {
    color:#596374;
    font-weight: 400;
    transition: background-color 0.5s,border-top-color 0.5s;
    padding : 0.4rem 0.8rem ; 
}

.tabs > li a:hover {
    border-top: 2px solid #2c3e50;
}

.tabs > li a.router-link-exact-active {
    border: 1px solid #cacaca;
    border-bottom: 3px solid white;
    border-top: 2px solid #2c3e50;
    position: relative;
}
</style>



// WEBPACK FOOTER //
// my-matchs.vue?c77b0628